"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilterCustomers = exports.ADDRESS_FIELDS = exports.filterGroupDefinitions = exports.getAddressPart = exports.getMatchLevel = void 0;
var get_1 = __importDefault(require("lodash/fp/get"));
var filter_1 = require("utils/filter");
var constants_1 = require("../constants");
var getMatchLevel = function (customer) { var _a, _b; return ((_b = (_a = customer.rechCustomer) === null || _a === void 0 ? void 0 : _a.crawledMigrationCustomer) === null || _b === void 0 ? void 0 : _b.matchLevel) || 'notFound'; };
exports.getMatchLevel = getMatchLevel;
var matchLevelDef = (0, filter_1.makeGroupDef)('Match Level', function (customer) { var _a; return (_a = constants_1.MATCH_LEVEL_MAPPER[(0, exports.getMatchLevel)(customer)].text) !== null && _a !== void 0 ? _a : 'Empty'; });
var getAddressPart = function (field) { return function (customer) { var _a, _b; return customer.rechCustomer ? (_b = (_a = customer.rechCustomer.address) === null || _a === void 0 ? void 0 : _a[field]) !== null && _b !== void 0 ? _b : 'Empty' : ''; }; };
exports.getAddressPart = getAddressPart;
var cityGroupDef = (0, filter_1.makeGroupDef)('City', (0, exports.getAddressPart)('city'));
var stateGroupDef = (0, filter_1.makeGroupDef)('State', (0, exports.getAddressPart)('state'));
var postalCodeGroupDef = (0, filter_1.makeGroupDef)('Postal Code', (0, exports.getAddressPart)('postalCode'));
exports.filterGroupDefinitions = [matchLevelDef, cityGroupDef, stateGroupDef, postalCodeGroupDef];
exports.ADDRESS_FIELDS = ['country', 'city', 'state', 'postalCode', 'line1', 'line2'];
exports.useFilterCustomers = (0, filter_1.makeUseFilterItems)(__spreadArray([(0, get_1.default)('name'), (0, get_1.default)('rechCustomer.name')], __read(exports.ADDRESS_FIELDS.map(exports.getAddressPart)), false), exports.filterGroupDefinitions);
